import cn from 'classnames';
import { FormattedDate } from 'react-intl';

import styles from './PaymentPlanCard.module.css';
import { FormattedCurrency } from '../../../../iwIntlProvider/FormattedCurrency';
import { PaymentPlanStatus } from '../Dashboard.types';

export const PaymentPlanCard = ({
    created,
    funded_at,
    reference,
    sellerName,
    amount,
    status
}: {
    created: string;
    funded_at?: string | null;
    reference: string;
    sellerName: string;
    amount: number;
    status: PaymentPlanStatus;
}) => {
    return (
        <div className={styles.paymentCard}>
            <div>
                <div className={styles.created}>
                    <FormattedDate
                        value={new Date(funded_at ? funded_at : created)}
                    />
                </div>
                <div className={styles.reference}>{reference}</div>
                <div className={styles.sellerName}>{sellerName}</div>
            </div>
            <div className={styles.right}>
                <div className={styles.invoicedAmountTitle}>
                    Invoiced amount:
                </div>
                <FormattedCurrency
                    className={styles.invoicedAmount}
                    value={amount}
                />
                <div className={styles.statusContainer}>
                    {STATUS_TO_COMPONENT[status]}
                </div>
            </div>
        </div>
    );
};

const ActiveStatus = () => (
    <>
        <span className={cn(styles.statusIcon, styles.activeIcon)} />
        <span>Active</span>
    </>
);

const OverdueStatus = () => (
    <>
        <span className={cn(styles.statusIcon, styles.overdueIcon)} />
        <span>Overdue</span>
    </>
);

const CompletedStatus = () => (
    <>
        <span className={styles.statusIcon} />
        <span>Completed</span>
    </>
);

const PendingStatus = () => (
    <>
        <span className={styles.statusIcon} />
        <span>Pending</span>
    </>
);

const ScheduledStatus = () => (
    <>
        <span className={styles.statusIcon} />
        <span>Not started</span>
    </>
);

const CancelledStatus = () => (
    <>
        <span className={styles.statusIcon} />
        <span>Cancelled</span>
    </>
);

const ApprovedStatus = () => (
    <>
        <span className={cn(styles.statusIcon, styles.approvedIcon)} />
        <span>Approved</span>
    </>
);

const ExpiredStatus = () => (
    <>
        <span className={styles.statusIcon} />
        <span>Expired</span>
    </>
);

const UnknownStatus = () => (
    <>
        <span className={styles.statusIcon} />
        <span>Unknown</span>
    </>
);

const DeclinedStatus = () => (
    <>
        <span className={cn(styles.statusIcon, styles.declinedIcon)} />
        <span>Declined</span>
    </>
);

const PartialStatus = () => (
    <>
        <span className={cn(styles.statusIcon, styles.partialIcon)} />
        <span>Partial approval</span>
    </>
);

const STATUS_TO_COMPONENT = {
    ongoing: <ActiveStatus />,
    overdue: <OverdueStatus />,
    ended: <CompletedStatus />,
    pending: <PendingStatus />,
    approved: <ApprovedStatus />,
    expired: <ExpiredStatus />,
    declined: <DeclinedStatus />,
    scheduled: <ScheduledStatus />,
    cancelled: <CancelledStatus />,
    unknown: <UnknownStatus />,
    partial: <PartialStatus />
} as const satisfies Record<PaymentPlanStatus, React.ReactNode>;
